import { isStandaloneDisplay } from "./pushNotifications";

export function isIosDevice() {
  if (typeof navigator === "undefined") return false;
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
}

/** Safari on iOS (no programmatic install). */
export function isIosSafariInstall() {
  if (!isIosDevice() || isStandaloneDisplay()) return false;
  return !/CriOS|FxiOS|EdgiOS/.test(navigator.userAgent);
}

export function isAndroidDevice() {
  if (typeof navigator === "undefined") return false;
  return /Android/i.test(navigator.userAgent);
}

export function getInstallPromptMode(canNativeInstall) {
  if (canNativeInstall) return "native";
  if (isIosSafariInstall()) return "ios";
  return "generic";
}
